import { ArticleJsonLd, BreadcrumbJsonLd } from 'next-seo';
import PropTypes from 'prop-types';

import { toAbsoluteLink, toBlogCategoryLink, toBlogTagLink } from 'lib/links';
import placeholder from 'lib/placeholder';

import APP from 'constants/app';
import LINKS from 'constants/links';

const Schema = ({ category = null, slug, tag = null }) => {
  const pageLink = category ? toBlogCategoryLink(slug) : toBlogTagLink(slug);

  return (
    <>
      <BreadcrumbJsonLd
        itemListElements={[
          {
            position: 1,
            name: placeholder('breadcrumbs.app'),
            item: APP.URL,
          },
          {
            position: 2,
            name: placeholder('breadcrumbs.blog'),
            item: toAbsoluteLink(LINKS.BLOG),
          },
          {
            position: 3,
            name: category || tag,
            item: toAbsoluteLink(pageLink),
          },
        ]}
      />
      <ArticleJsonLd
        description={placeholder('seo.blog.description')}
        title={`Arquivos ${category || tag} | Promobit`}
        url={toAbsoluteLink(pageLink)}
      />
    </>
  );
};

Schema.propTypes = {
  category: PropTypes.string,
  slug: PropTypes.string.isRequired,
  tag: PropTypes.string,
};

export default Schema;
